/** Login Drawer **/

$(".site-settings,.close-login").on('click', function(i){
  $("#login-drawer").toggleClass("active");
});

$(document).ready(function() {
  $('#register-form').hide();
  $("#login-form-btn").addClass("active-btn");

  $('#login-form-btn').click(function() {
    $(this).addClass("active-btn");
    $("#register-form-btn").removeClass("active-btn");
    $('#login-form').show("fast");
    $('#register-form').hide("fast");
  });

  $('#register-form-btn').click(function() {
    $(this).addClass("active-btn");
    $("#login-form-btn").removeClass("active-btn");
    $('#login-form').hide("fast");
    $('#register-form').show("fast");
  });
});

/*
* Log the customer in with their email and password.
*/


function validateEmail($email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test( $email );
}

function ValidateDOB(dateString) {
  
  var parts = dateString.split("-");
  var dtDOB = new Date(parts[2] + "/" + parts[1] + "/" + parts[0]);
  var dtCurrent = new Date();
  if (dtCurrent.getFullYear() - dtDOB.getFullYear() < 18) {
    return false;
  }

  if (dtCurrent.getFullYear() - dtDOB.getFullYear() == 18) {

    //CD: 11/06/2018 and DB: 15/07/2000. Will turned 18 on 15/07/2018.
    if (dtCurrent.getMonth() < dtDOB.getMonth()) {
      return false;
    }
    if (dtCurrent.getMonth() == dtDOB.getMonth()) {
      //CD: 11/06/2018 and DB: 15/06/2000. Will turned 18 on 15/06/2018.
      if (dtCurrent.getDate() < dtDOB.getDate()) {
        return false;
      }
    }
  }
  return true;
}


function createAccount(firstName, lastName, email, password){
  var escapedData = {
    firstName: escape(firstName),
    lastName: escape(lastName),
    email: escape(email),
    password: escape(password).replace(/\+/g, '%2B')
  }
  var data = 'form_type=create_customer&utf8=%E2%9C%93&customer%5Bfirst_name%5D=';
  data += escapeData.firstName;
  data += '&customer%5Blast_name%5D=';
  data += escapedData.lastName;
  data += '&customer%5Bemail%5D=';
  data += escapedData.email;
  data += '&customer%5Bpassword%5D=';
  data += escapedData.password;
  jQuery.post('/account', data)
  .done(function(response){
    var logErrors = jQuery(response).find('.errors').text();
    if (logErrors != '' && logErrors != 'undefined'){
      alert(logErrors);
    }
    else{
      alert('success!');
    }
  }).fail(function(){alert('error could not submit');});
  return false;
}


function validateCaptcha(token){

  var form = new FormData();
  form.append("secret", "6LfAGaccAAAAAGEfrW0M7UkWdAm3kfG8RGkM5Kgr");
  form.append("response", token);

  var settings = {
    "url": "https://www.google.com/recaptcha/api/siteverify",
    "method": "POST",
    "timeout": 0,
    "crossDomain": true,
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
     "dataType": "json",
    "headers": {
      "Host": "google.com",
      "Origin": "https://libertyzenousa.myshopify.com/",
      "Content-Type": "application/json"
    },
    "data": form
  };

  $.ajax(settings).done(function (response) {
    console.log(response);
  });

}

jQuery(function() {
  jQuery('#login-drawer #customer_login .errors').hide();
  jQuery('#login-drawer #RegisterForm .errors').hide();
  
  jQuery('#login-drawer #customer_login').submit(function(event) {
    event.preventDefault();
    var email = jQuery('#CustomerEmail').val();
    var password = jQuery('#CustomerPassword').val();
    var honeypot = jQuery('#contact_me_by_fax_only').val();

    if(honeypot.length === 0){

      if( !validateEmail(email)) { 
        jQuery('#login-drawer #customer_login .errors').empty();
        jQuery('<ul><li>Please enter correct email address.</li></ul>').appendTo('#login-drawer #customer_login .errors');
        jQuery('#login-drawer #customer_login .errors').show();
        return false;
      }

      if(email.length === 0 || password.length === 0){
        jQuery('#login-drawer #customer_login .errors').empty();
        jQuery('<ul><li>Please enter your email & password</li></ul>').appendTo('#login-drawer #customer_login .errors');
        jQuery('#login-drawer #customer_login .errors').show();
        return false;
      }

      var data = jQuery(this).serialize();
      //create new account
      jQuery.post('/account/login', data)
      .done(function(data){

        if (data.indexOf('Incorrect email or password.') !== -1) {
          jQuery('<ul><li>Incorrect email or password.</li></ul>').appendTo('#login-drawer #customer_login .errors');
          jQuery('#login-drawer #customer_login .errors').show();
        } else {
          console.log('success');
          document.location.href = '/account';
        }
      }).fail(function(){console.log('error');});
      return false;
    } else {
      return false;
    }
  }); 


  /*
* Add the customer in with their email and password.
*/
  jQuery('#login-drawer #RegisterForm').submit(function(event) {
    event.preventDefault();

    var first_name = jQuery('#FirstName').val();
    var last_name = jQuery('#LastName').val();
    var dob = jQuery('#DateOfBirth').val();
    var email = jQuery('#RegisterForm-email').val();
    var password = jQuery('#RegisterForm-password').val();

    if(first_name.length === 0 || last_name.length === 0 || dob.length === 0 || email.length === 0 || password.length === 0){
      jQuery('#login-drawer #RegisterForm .errors').empty();
      jQuery('<ul><li>Please fill all the required fields.</li></ul>').appendTo('#login-drawer #RegisterForm .errors');
      jQuery('#login-drawer #RegisterForm .errors').show();
      return false;
    }

    if( !validateEmail(email)) { 
      jQuery('#login-drawer #RegisterForm .errors').empty();
      jQuery('<ul><li>Please enter correct email address.</li></ul>').appendTo('#login-drawer #RegisterForm .errors');
      jQuery('#login-drawer #RegisterForm .errors').show();
      return false;
    }

    if (!ValidateDOB(dob)){
      jQuery('#login-drawer #RegisterForm .errors').empty();
      jQuery('<ul><li>Age should be 18 years or above.</li></ul>').appendTo('#login-drawer #RegisterForm .errors');
      jQuery('#login-drawer #RegisterForm .errors').show();
      return false;
    }

    if ($('#accepts_terms').is(':checked')) {
      var register_data = jQuery(this).serialize();
      console.log(register_data);
      
      //create new account
      jQuery.post('/account', register_data)
      .done(function(response){
        var logErrors = jQuery(response).find('.form-message.errors').text();
        var Errors = jQuery(response).find('.errors').text();
        console.log(logErrors);
        console.log(Errors);
        //if there are errors show them in the html form
        if (logErrors != "" && logErrors != 'undefined' && Errors != "" && Errors != 'undefined'){
          jQuery('#login-drawer #RegisterForm .errors').html(logErrors);
          jQuery('#login-drawer #RegisterForm .errors').html(Errors);
          jQuery('#login-drawer #RegisterForm .errors').show();

          //if account creation is successful show checkout page
        }else{
          console.log('success');
          document.location.href = '/account';
        }
      }).fail(function(){console.log('error');});
      return false;


    }
    else {
      jQuery('#login-drawer #RegisterForm .errors').empty();
      jQuery('<ul><li>You must agree with the terms and conditions of sales to check out.</li></ul>').appendTo('#login-drawer #RegisterForm .errors');
      jQuery('#login-drawer #RegisterForm .errors').show();
      return false;
    }

  }); 
});


$(document).on('mouseenter', '.gridSwatches li:not(.noImg)', function(e){
  var $this = $(this),
      newImage = $(this).attr('rel'),
      gridWrapper = $(this).parents('.grid-view-item').find('.grid-view-item__link');
  $(gridWrapper).addClass("showLoading");
  $(gridWrapper).find('.variantImg').css("background-image", "url('"+newImage+"')");
  var image = document.createElement('img');
  image.src = newImage;
  image.onload = function () {
    $(gridWrapper).removeClass("showLoading").addClass("showVariantImg");
    $this.siblings().removeClass("active");
    $this.addClass("active");
  };
  return false;
});


jQuery.ajax({
   url:'/pages/faq',
   type:'GET',
   success: function(data){
       $('#product-faq').html($(data).find('#shopify-section-faq-template').html());
   }
});

setTimeout(function(){ $("a.zooomy__hhrt").attr("href", "/pages/wishify"); }, 3000);

function tabs(id){
	$(".product-tabs #" + id).toggle("slow");
} 